<template>
  <div class="page-wrapper">
    <!-- Page Title -->
    <div class="page-title-section">
      <h1 class="page-title">Prenota una Corsa</h1>
      <p class="page-subtitle">Seleziona il servizio per creare una nuova prenotazione</p>
    </div>

    <!-- Servizi attivi: Pickup ed Escort.
         Delivery resta dismesso (F6: il backend risponde 410). -->
    <el-row :gutter="24" justify="center" class="cards-row">
      <el-col :xs="24" :sm="12" :md="8">
        <CardComponent
          :imgSrc="pickupImg"
          title="PICK UP & DELIVERY"
          label="La macchina deve effettuare dei lavori di manutenzione in officina"
          @click="handleCardClickPickup"
          :selectedCar="card==1"
          :isRouter="false"
        ></CardComponent>
      </el-col>
      <el-col :xs="24" :sm="12" :md="8">
        <CardComponent
          :imgSrc="escortImg"
          title="ACCOMPAGNA UN CLIENTE"
          label="Il delivery riguarda il cliente, non una macchina"
          @click="handleCardClickEscort"
          :selectedCar="card==3"
          :isRouter="false"
        ></CardComponent>
      </el-col>
    </el-row>

    <!-- Booking Form Sections -->
    <div id="pickupSection" class="booking-section">
      <el-card v-if="card == 1" shadow="hover">
        <PickupComponent />
      </el-card>
    </div>
    <div id="escortSection" class="booking-section">
      <el-card v-if="card == 3" shadow="hover">
        <EscortComponent />
      </el-card>
    </div>
  </div>
</template>

<script>
import PickupComponent from "../Components/PickupComponent.vue";
import EscortComponent from "../Components/EscortComponent.vue";
import customerAPI from "../services/customerAPI.js";
import bookingAPI from "../services/bookingAPI.js";
import partnerAPI from "../services/partnerAPI.js";
import pickupImg from "../assets/pickup2-yellow.png";
import escortImg from "../assets/escort2-yellow.png";
import { isLoggedStore } from "../store/logged";
import { ref,nextTick } from "vue";
import store from "../store/prenotazione.js";
import CardComponent from "@/Components/CardComponent.vue";
export default {
  name: "PrenotazioniInfoPage",
  components: {
    PickupComponent,
    EscortComponent,
    CardComponent,
  },
  setup() {
    store.customers = null;
    store.customersCascader = null;
    store.customerSelected = null;
    store.headquarters = null;
    store.headquartersCascader = null;
    store.heaquarterSelected = null;
    store.cars = [];
    store.carsCascader = [];
    store.carSelected = null;
    store.originPointAddress = "";
    store.originPointStreetNumber = "";
    store.originPointCity = "";
    store.originPointCap = "";
    store.originPointProvince = "";
    store.destinationPointAddress = "";
    store.destinationPointStreetNumber = "";
    store.destinationPointCity = "";
    store.destinationPointCap = "";
    store.destinationPointProvince = "";
    store.rangeKmGonePickup = 0;
    store.rangeCostGonePickup = 0;
    store.rangeKmReturnPickup = 0;
    store.rangeCostReturnPickup = 0;
    store.rangeKmGoneEscort = 0;
    store.rangeCostGoneEscort = 0;
    store.rangeKmReturnEscort = 0;
    store.rangeCostReturnEscort = 0;

    let card = ref(0);

    const storeLogin = isLoggedStore();

   const  scrollToSection= (sectionId)=> {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    }

    //cliente
    let customersCascader = ref([]);
    const customers = ref([]);

    let partner=ref({});

    const loadCustomers = async () => {
      try {
        const responsePartner = await partnerAPI.getPartnerByEmployee(storeLogin.id);

        partner.value = responsePartner.data[0].headquarters[0].partner;
        const response = await customerAPI.getCustomersByPartner(partner.value.id);

        response.data.forEach((customer) => {
          if (customer.is_alive == true) {
            let tableRow = {
              value: customer.id,
              label: `${customer.name} ${customer.surname}, ${customer.mail}`,
            };
            customers.value.push(customer);
            customersCascader.value.push(tableRow);
          }
        });
      } catch (error) {
        console.error(error);
      }
    };

    //sede
    let headquartersCascader = ref([]);
    const headquarters = ref([]);

    const loadHeadquarters = async () => {
      try {
        const response = await bookingAPI.getHeadquartersByEmployee(storeLogin.id);


        response.data[0].headquarters.forEach((headquarter) => {
          let tableRow = {
            value: headquarter.id,
            label: `${headquarter.address} ${headquarter.street_number} ${headquarter.city}`,
          };
          headquartersCascader.value.push(tableRow);
          headquarters.value.push(headquarter);
        });
      } catch {
        console.error("error");
      }
    };

    const handleCardClickPickup = () => {
      card.value = 1;
      nextTick(() => {
        scrollToSection('pickupSection');
      });
    };

    const handleCardClickEscort = () => {
      card.value = 3;
      nextTick(() => {
        scrollToSection('escortSection');
      });
    };

    loadCustomers();
    loadHeadquarters();

    store.customers = customers.value;
    store.customersCascader = customersCascader.value;
    store.headquarters = headquarters.value;
    store.headquartersCascader = headquartersCascader.value;

    return {
      store,
      card,
      handleCardClickPickup,
      handleCardClickEscort,
      pickupImg,
      escortImg,
      partner,
      scrollToSection
    };
  },
};
</script>

<style scoped>
.page-wrapper {
  padding: 24px;
  max-width: 1400px;
  margin: 0 auto;
}

.page-title-section {
  margin-bottom: 32px;
}

.page-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: #171717;
  margin: 0 0 8px 0;
  padding-bottom: 12px;
  border-bottom: 3px solid #4B30F2;
  display: inline-block;
}

.page-subtitle {
  font-size: 0.95rem;
  color: #737373;
  margin: 0;
}

.cards-row {
  margin-bottom: 32px;
}

.booking-section {
  margin-bottom: 24px;
}

@media (max-width: 768px) {
  .page-wrapper {
    padding: 16px;
  }
}
</style>
